import { atom } from 'jotai';

/**
 * Cross-tree signal for "the dictate onboarding flow currently has dictation
 * active". Written by `useOnboardingDictationMode`; read by
 * `useDesktopDictationHotkey` in the always-mounted `DictationBubble`.
 */
export const onboardingDictationActiveAtom = atom(false);

/** Open tone-step category; drives the left accordion and right-panel preview. */
export const activeToneCategoryIdAtom = atom<string | null>(null);
